// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronDown: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.971 16.482a1.496 1.496 0 0 1-1.06-.433l-5.972-5.972a1.5 1.5 0 0 1 2.12-2.12l4.912 4.941 4.927-4.747a1.493 1.493 0 1 1 2.06 2.149l-5.972 5.763a1.493 1.493 0 0 1-1.015.419z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const ChevronDownOffset: IconOffset = {
    vertical: 31,
    horizontal: 18,
};

export default React.memo(ChevronDown);
